import React from "react";
import { Sparkles, RefreshCw } from "lucide-react";

const fmt = (n) => (n ?? 0).toLocaleString("it-IT");

export default function CreditsBar({ user, className = "" }) {
  if (user?.unlimited) {
    return (
      <div data-testid="credits-bar" className={`rounded-2xl border border-brand-pink/40 bg-card p-4 ${className}`}>
        <div className="flex items-center justify-between mb-2.5">
          <span className="text-xs font-mono-label uppercase tracking-wider text-muted-foreground flex items-center gap-1.5">
            <Sparkles className="h-3.5 w-3.5 text-brand-pink" /> Battute rimanenti
          </span>
          <span data-testid="credits-count" className="text-sm font-semibold text-brand-pink">Illimitate ∞</span>
        </div>
        <div className="h-2 rounded-full overflow-hidden bg-gradient-to-r from-brand-blue to-brand-pink" />
        <p className="mt-2 text-xs text-muted-foreground">Account illimitato — nessun limite di traduzione.</p>
      </div>
    );
  }
  const subscribed = user?.sub_status === "active";
  const subChars = user?.sub_chars ?? 0;
  const subLimit = user?.sub_limit ?? 0;
  const topup = user?.topup_chars ?? 0;
  const topupTotal = user?.topup_total ?? 0;
  const remaining = subChars + topup;

  const numer = subscribed ? subChars : topup;
  const denom = subscribed ? (subLimit || 1) : (topupTotal || Math.max(topup, 1));
  const pct = Math.max(0, Math.min(100, (numer / denom) * 100));
  const low = remaining <= denom * 0.1;
  const empty = remaining <= 0;

  const resetDate = user?.sub_period_end ? new Date(user.sub_period_end).toLocaleDateString("it-IT", { day: "2-digit", month: "long" }) : null;

  let barColor = "bg-gradient-to-r from-brand-blue to-brand-pink";
  if (empty) barColor = "bg-destructive";
  else if (low) barColor = "bg-amber-500";

  return (
    <div data-testid="credits-bar" className={`rounded-2xl border border-border bg-card p-4 ${className}`}>
      <div className="flex items-center justify-between mb-2.5">
        <span className="text-xs font-mono-label uppercase tracking-wider text-muted-foreground flex items-center gap-1.5">
          <Sparkles className={`h-3.5 w-3.5 ${empty ? "text-destructive" : "text-brand-pink"}`} /> Battute rimanenti
        </span>
        <span data-testid="credits-count" className={`text-sm font-semibold tabular-nums ${empty ? "text-destructive" : ""}`}>
          {fmt(remaining)}
        </span>
      </div>
      <div className="h-2 rounded-full bg-secondary overflow-hidden">
        <div
          className={`h-full rounded-full transition-[width] duration-500 ${barColor}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="mt-2 flex items-center justify-between text-xs text-muted-foreground">
        {subscribed ? (
          <span className="flex items-center gap-1">
            <RefreshCw className="h-3 w-3" /> Abbonamento: {fmt(subChars)}/{fmt(subLimit)}{resetDate ? ` · rinnovo ${resetDate}` : ""}
          </span>
        ) : (
          <span>{fmt(topup)} battute disponibili</span>
        )}
        {topup > 0 && subscribed && <span className="text-brand-blue">+{fmt(topup)} extra</span>}
      </div>
      {empty && <p className="text-xs text-destructive mt-2">Saldo esaurito — abbonati o acquista un pacchetto per continuare.</p>}
    </div>
  );
}
